<!--
Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
Unauthorized use, copying, distribution, displaying, or public performance
of this file, via any medium, is strictly prohibited. All information
contained herein is proprietary and confidential and may not be shared
with any third party without the express written consent of Reciprocity, Inc.
-->

<template>
  <span class="jira-issue-field-textarea">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-if="renderedValue" v-html="renderedValue" />
    <span v-if="value && !renderedValue">{{ value }}</span>
  </span>
</template>

<script>
import fieldBase from './fieldBase';

export default {
  mixins: [fieldBase],
};
</script>
